import styled from "styled-components";
import Select from "react-select";

export const UploadContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 2rem 0;
	width: 536px;
`;

export const UploadArea = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 2rem;
	border: 2px dashed #e5e7eb;
	border-radius: 8px;
	width: 100%;
	margin-bottom: 1rem;
`;

export const FileInput = styled.input`
	display: none;
`;

export const UploadButton = styled.label`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	padding: 12px 24px;
	color: #31475a;
	border: none;
	border-radius: 6px;
	cursor: ${props => (props.allowed ? "pointer" : "not-allowed")};
	font-size: 12px;
	font-weight: 600;
`;

export const FileInfoArea = styled.div`
	width: 100%;
	height: 68px;
	display: flex;
	align-items: center;
	padding: 0 16px;
	background-color: #f9fafb;
	border-radius: 10px;
	gap: 16px;
`;

export const FileInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const FileName = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	font-weight: 700;
	color: #31475a;
`;

export const FileSize = styled.span`
	color: #9f9fa9;
	font-size: 12px;
`;

export const ValidationResults = styled.div`
	width: 100%;
	width: 536px;
	margin-top: 1rem;
`;

export const ErrorMessage = styled.div`
	width: 100%;
	max-height: 245px;
	background: #fff1f2;
	border: 1px solid #ffccd3;
	border-radius: 10px;
	padding: 16px;
	overflow-y: auto;
`;

export const MessageHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-weight: 700;
	margin-bottom: 8px;
`;

export const ErrorTitle = styled.div`
	color: #c70036;
	font-size: 12px;
`;

export const ErrorListContainer = styled.div`
	max-height: 185px;
	overflow-y: auto;
`;

export const ErrorListItem = styled.div`
	background: #ffffff;
	border: 1px solid #ffccd3;
	border-radius: 4px;
	padding: 8px;
	color: #c70036;
	margin-bottom: 4px;
	font-size: 10px;
`;

export const ErrorListFooter = styled.div`
	font-size: 12px;
	color: #c70036;
`;

export const SuccessMessage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 8px;
	background: #ecfdf5;
	border: 1px solid #a4f4cf;
	padding: 1rem;
	border-radius: 4px;
	font-weight: 600;
`;

export const SuccessTitle = styled.div`
	color: #007a55;
	font-size: 12px;
	font-weight: ${props => (props.bold ? "700" : "400")};
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const DownloadErrorsButton = styled.button`
	display: flex;
	height: 20px;
	align-items: center;
	gap: 8px;
	margin-top: 10px;
	padding: 8px;
	color: #c70036;
	background-color: #ffe4e6;
	border: 1px solid #ffa1ad;
	border-radius: 4px;
	cursor: pointer;
	font-size: 8px;
`;

export const SearchSelect = styled(Select)`
	width: 536px;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	margin-bottom: 2rem;
`;

export const StepButton = styled.button`
	max-width: ${props => (props.primary ? "199px" : "108px")};
	height: 39px;
	background-color: ${props => (props.primary ? "#534B99" : "white")};
	color: ${props => (props.primary ? "white" : "#534B99")};
	border: ${props => (props.primary ? "none" : "1px solid #534B99")};
	border-radius: 8px;
	padding: 8px 32px;
	font-weight: 700;
`;
